import { Sku } from "../types/skus"

export const findSkuByOfferSkuId = (skus: Sku[], id?: number) => {
  const sku = skus.find(sku => sku.offer_sku_id === id)
  return sku
}